/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

ragadjust = function (s, method) {

    if (document.querySelectorAll) {

        var eles = document.querySelectorAll(s),
            elescount = eles.length,

            preps =
                /(\s|^|>)((a|i|o|s|u|z|k|v)\s)+/gi,

            smallwords =
                /(\s|^)(([a-zA-Z-_(]{1,2}('|’)*[a-zA-Z-_,;]{0,1}?\s)+)/gi, // words with  3 or less characters

            dashes = /([-–—])\s/gi,

            emphasis =
                /(<(strong|em|b|i)>)(([^\s]+\s*){2,3})?(<\/(strong|em|b|i)>)/gi;

        while (elescount-- > 0) {

            var ele = eles[elescount],
                elehtml = ele.innerHTML;

            if (method == 'prepositions' || method == 'all')

            // replace prepositions (greater than 3 characters)
                elehtml = elehtml.replace(preps, function
                    (contents, p1, p2) {
                    return p1 + p2.replace(/\s/gi, '&#160;');
                });

            // if (method == 'small-words' || method == 'all')
            //
            // // replace small words
            //     elehtml = elehtml.replace(smallwords, function
            //         (contents, p1, p2) {
            //         return p1 + p2.replace(/\s/g, '&#160;');
            //     });

            if (method == 'dashes' || method == 'all')

            // replace small words
                elehtml = elehtml.replace(dashes, function (contents) {
                    return contents.replace(/\s/g, '&#160;');
                });

            if (method == 'emphasis' || method == 'all')

            // emphasized text
                elehtml = elehtml.replace(emphasis, function
                    (contents, p1, p2, p3, p4, p5) {
                    return p1 + p3.replace(/\s/gi, '&#160;') + p5;
                });

            ele.innerHTML = elehtml;

        }

    }

};


(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {



                // JavaScript to be fired on all pages
            },
            finalize: function () {

                $('#myCarousel').bcSwipe();
                $(window).load(function () {
                    ragadjust("p", "all");
                    ragadjust(".sidebar .partner li", "all");
                    ragadjust("p span", "all");
                });

                $('.newsletter-link').click(function (e) {
                    e.preventDefault();
                    var body = $("html, body");
                    $('.primary-navigation').slideUp();
                    $('.burger-menu').removeClass('active');
                    body.stop().animate({scrollTop: $('.newsletter').offset().top - 100}, 500, 'swing', function () {

                    });
                });


                //burger menu toggle
                $('A.burger-menu').click(function (e) {
                    e.preventDefault();
                    $(this).toggleClass('active');
                    $('.primary-navigation').slideToggle();
                });

                $(window).scroll(function () {

                    if (typeof checkScroll !== 'undefined') {
                        clearTimeout(checkScroll);
                    }

                    var checkScroll = setTimeout(function () {
                        if ($(window).scrollTop() === 0) {
                            $('.header').removeClass('is_stuck');
                        } else {
                            $('.header').addClass('is_stuck');
                        }
                    }, 100);


                });
                // JavaScript to be fired on all pages, after page specific JS is fired

                $(document).on('click','.fotogalerie a.btn',function (e) {
                    e.preventDefault();
                    var celkem = $(this).closest('.fotogalerie').find('div').length,
                        pocet = $(this).closest('.fotogalerie').find('div:visible').length + 4;
                    $(this).closest('.fotogalerie').find('div:lt(' + pocet + ')').slideDown(function () {
                        $(window).resize();
                    });
                    if (celkem <= pocet) {
                        $(this).fadeOut();
                    }
                });

                $(".hover-play").hover(
                    function () {
                        $(this).find("video")[0].play();
                    }, function () {
                        $(this).find("video")[0].pause();
                    });
                $('.filtr form input[type="checkbox"]').change(function () {
                    $(".filtr form").submit();
                });

                $('#error-modal').on('show.bs.modal', function (e) {
                    setTimeout(function () {
                        $('.modal-backdrop').addClass('error');
                    }, 1);

                });

                //newsletter
                $('.newsletter form').submit(function (e) {
                    e.preventDefault();
                    var form = $(this);

                    $(this).find('input[type="email"]').removeClass('error');
                    //$('#error-modal').modal('hide');
                    //$('#success-modal').modal('hide');
                    if ($(this).find('input[type="email"]').val() == '') {
                        $('#error-modal').modal('show');
                        $(this).find('input[type="email"]').addClass('error');
                        return false;
                    }
                    $.post(ajaxurl, {'action': 'mcregister', 'newsletter-signup': $(this).find('input[type="email"]').val()}, function (data) {
                        data = jQuery.parseJSON(data);
                        if (data.isValid == 3) {
                            $('#error-modal').modal('show');
                        } else {
                            form.find('input[type="email"]').val('');
                            //      $('#error-modal').modal('hide');
                            $('#success-modal').modal('show');
                        }

                    });
                });
                $(".header").stick_in_parent();
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
                ragadjust(".home-slider h3", "all");
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        },
        'single': {
            finalize: function () {
                $(window).load(function () {
                    $(window).resize(function () {
                        if ($(window).width() > 992) {
                            $('.sidebar').height($('.body-content').outerHeight());
                        } else {
                            $('.sidebar').removeAttr('style');
                        }
                    }).resize();
                    $(window).resize(function () {
                        if ($(window).width() > 992) {

                            $(".clanky-sidebar").stick_in_parent({
                                inner_scrolling: false
                            });
                        } else {
                            $(".clanky-sidebar").trigger("sticky_kit:detach");
                            $()
                        }
                    }).resize();
                });
            }
        },
        'page_template_o_projektu': {
            finalize: function () {
                $(window).load(function () {

                    $(window).resize(function (){
                        if($(window).width()> 1114) {
                            $('.o-projektu-video .green').outerHeight($('.o-projektu-video img').height());
                            $('.carousel-oprojektu .carousel-text').outerHeight($('#myCarousel').height());
                        }else{
                            $('.o-projektu-video .green').removeAttr('style');
                            $('.carousel-oprojektu .carousel-text').removeAttr('style');
                        }
                    }).resize();

                });

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
